import request from '@/utils/request'

//获取会员状态
export function memberInfo(data) {
    return request({
        url: `/Member/GetMemberInfo`,
        method: 'post',
        data
    })
}

//获取会员动态列表
export function memberPostList(data) {
    return request({
        url: `/MemberPost/GetMemberPostList`,
        method: 'post',
        data
    })
}


//获取会员话题列表
export function memberTopicList(data) {
    return request({
        url: `/MemberPost/GetMemberTopicList`,
        method: 'post',
        data
    })
}


//删除动态
export function deleteMemberPost(data) {
    return request({
        url: `/MemberPost/DeleteMemberPost`,
        method: 'post',
        data
    })
}

